import { TermsOfUseForManufacturerServicesSubPage } from '../TermsOfUseForManufacturerServicesSubPage';

export const ServiceEbikeManualsPage = () => (
  <TermsOfUseForManufacturerServicesSubPage page="portal.termsOfUse.manufacturerServices.ebikeManuals" />
);
